export default class extends HTMLElement {
  connectedCallback () {
    window.dispatchEvent(new CustomEvent(this.dataset.eventName, {
      detail: this.dataset.payload ? JSON.parse(this.dataset.payload) : {},
      bubbles: true,
      composed: true
    }))
    this.remove()
  }
}
